/*
 * 真偽値関連のバリデーション
 */
/**
 * 値が true か
 * @param text エラー文言
 * @returns {function(*=): string}
 */
export const isTrue = (text) => (value) => value === true ? undefined : text;
